export default "__VITE_ASSET__C5$38C$b__"